import React from "react";
import { TextField, Grid } from "@material-ui/core";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { getIcon } from "../../../icon/icon";
import { getProducts } from "../../../state/actions/ProductActions";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import { withTranslation } from "react-i18next";

class ListProductsPage extends React.Component {
  constructor() {
    super();

    this.state = {
      newTagText: "",
      addTagModalOpen: false,
      originalData: [],
      searchedData: [],
      loading: false,
      products: [],
      selectedGroupIds: []
    };
  }

  componentDidMount() {
    this.setupData();
  }

  componentDidUpdate() {
    if (JSON.stringify(this.state.products) !== JSON.stringify(this.props.products)) {
      const data = Object.keys(this.props.products).map((productKey) => { return this.props.products[productKey] });

      this.setState({
        originalData: data,
        searchedData: data,
        products: this.props.products
      });
    }
  }

  setupData() {
    this.setState({ loading: true });

    this.props.getProducts(() => {
      const data = Object.keys(this.props.products).map((productKey) => { return this.props.products[productKey] });

      this.setState({
        loading: false,
        originalData: data,
        searchedData: data,
        products: this.props.products
      });
    });
  }

  createHeaders() {
    return [
      {
        id: "ProductDisplayName",
        secondaryId: "ProductName",
        clickable: true,
        action: { path: "/products/{id}", identifier: "id" },
        align: "left",
        label: this.props.t('product.product-name')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id
      cell.secondaryId = header.secondaryId;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.state.searchedData.length === 0) {
      return (
        <PagePlaceholder
          image={getIcon("diamond.svg")}
          text={this.props.t('product.none-found')}
        />
      );
    } else {
      return (
        <SimpleTable
          handleSelection={selectedIds => {
            this.setState({ selectedGroupIds: selectedIds });
          }}
          dataId={"id"}
          cells={cells}
          headers={headers}
          rows={this.state.searchedData}
        />
      );
    }
  }

  search(searchText) {
    const text = searchText.toLowerCase();

    if (text === "") {
      this.setState({ searchedData: this.state.originalData });
    }

    const foundData = this.state.originalData.filter(data => {
      if (data.ProductDisplayName != null) {
        return data.ProductDisplayName.toLowerCase().includes(text)
      }

      return data.ProductName.toLowerCase().includes(text)
    });

    this.setState({ searchedData: foundData });
  }

  render() {

    return (
      <div>
        <HeaderBlock
          title={this.props.t('product.products')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <TextField
                  id="outlined-name"
                  label={this.props.t('product.search-products')}
                  value={this.state.routeName}
                  onChange={event => this.search(event.target.value)}
                  margin="dense"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          }
        />
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderData()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { products } = state.ProductReducer;
  return { products };
};

const mapDispatchToProps = dispatch => bindActionCreators({ getProducts }, dispatch);

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListProductsPage))
);

// EXPORT COMPONENT

export { hoc as ListProductsPage };
